export enum DictionaryType {
  PAYMENT_MODEL = 'PAYMENT_MODEL',
  CATEGORY = 'CATEGORY',
  MODEL_FAMILY = 'MODEL_FAMILY',
  DEVICE_FAMILY = 'DEVICE_FAMILY',
}
